var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16091",
    "data-name": "Group 16091",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7263",
    "data-name": "Path 7263",
    d: "M14.3,2.2a8.907,8.907,0,0,1,11.554,0,4.878,4.878,0,0,0,2.775,1.15,8.907,8.907,0,0,1,8.17,8.17,4.877,4.877,0,0,0,1.15,2.775,8.907,8.907,0,0,1,0,11.554,4.877,4.877,0,0,0-1.15,2.775,8.907,8.907,0,0,1-8.17,8.17,4.877,4.877,0,0,0-2.775,1.15,8.907,8.907,0,0,1-11.554,0,4.877,4.877,0,0,0-2.775-1.15,8.907,8.907,0,0,1-8.17-8.17A4.877,4.877,0,0,0,2.2,25.85,8.907,8.907,0,0,1,2.2,14.3a4.877,4.877,0,0,0,1.15-2.775,8.907,8.907,0,0,1,8.17-8.17A4.877,4.877,0,0,0,14.3,2.2Zm8.941,3.067a4.877,4.877,0,0,0-6.327,0,8.907,8.907,0,0,1-5.069,2.1,4.877,4.877,0,0,0-4.474,4.474,8.907,8.907,0,0,1-2.1,5.069,4.877,4.877,0,0,0,0,6.327,8.906,8.906,0,0,1,2.1,5.069,4.877,4.877,0,0,0,4.474,4.474,8.907,8.907,0,0,1,5.069,2.1,4.877,4.877,0,0,0,6.327,0,8.906,8.906,0,0,1,5.069-2.1,4.877,4.877,0,0,0,4.474-4.474,8.906,8.906,0,0,1,2.1-5.069,4.877,4.877,0,0,0,0-6.327,8.907,8.907,0,0,1-2.1-5.069,4.877,4.877,0,0,0-4.474-4.474A8.906,8.906,0,0,1,23.237,5.268Zm4.306,9.351a2.015,2.015,0,0,1,0,2.849l-8.059,8.059a2.015,2.015,0,0,1-2.849,0L12.6,21.5a2.015,2.015,0,0,1,2.849-2.849l2.6,2.6,6.635-6.635A2.015,2.015,0,0,1,27.543,14.619Z",
    transform: "translate(179.928 279.926)",
    fill: "#0f5a9c",
    fillRule: "evenodd",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/Confirmed.927164bfc26e4b558c92d7f7c1af1b8a.svg";
export { ForwardRef as ReactComponent };